<div class="card-body p-3">

    <div class="row">
        <div class="col-md-3">
            <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
            </app-benef-info>
        </div>
        <div class="col col-md-9" [class.section-disabled]="!itemBeneficiare?.id">

            <!-- ── Header ── -->
            <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="text-danger fw-bold" style="font-size: 13px;">Actes prescrits</span>
                <button class="btn btn-success btn-sm" (click)="showPresModal = true">
                    <i class="fas fa-file-medical me-1"></i>Nouvelle prescription
                </button>
            </div>

            <!-- ── Tableau prescriptions ── -->
            <div class="table-responsive" style="max-height: 300px;">
                <table class="table-bordered medication-table">
                    <thead>
                        <tr>
                            <th style="width: 5%;"><a style="cursor: pointer"
                                    (click)="getItemsPrescriptionActe()" title="Actualiser">
                                    <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp;#</th>
                            <th style="width: 75%;">Acte</th>
                            <th style="width: 10%;">Quantité</th>
                            <th style="width: 10%;text-align: center;">Option</th>
                        </tr>
                    </thead>
                    <tbody style="font-weight: 500;">
                        <tr *ngFor="let item of itemsPrescription; let indice = index" [ngClass]="{
                            'option-background-orange': item.is_entente_prealable && item.is_eligible !== false,
                            'option-background-red': item.is_exclu && item.is_eligible !== false,
                            'option-background-green': !item.is_exclu && !item.is_entente_prealable && item.is_eligible !== false,
                            'medoc-replaced': item.is_replaced,
                            'medoc-replacer': item.is_replacer,
                            'disabled-row': item.is_eligible === false
                        }">
                            <td>{{ indice + 1 }}</td>
                            <td>
                                {{ item.acte_libelle }}
                                <span *ngIf="item.is_eligible === false" class="badge bg-secondary ms-1"
                                    style="font-size:0.65rem;cursor:help"
                                    title="Acte prescrit par référence : ce prestataire n'est pas autorisé à l'exécuter directement">Référé</span>
                            </td>
                            <td style="text-align: right;">{{ item.quantite | IntegerFormatPipe}}</td>
                            <td>
                                <button *ngIf="canAdd(item) && item.is_eligible !== false"
                                    (click)="addItemToList(item)" class="btn btn-primary btn-sm"
                                    style="color: white;">Ajouter</button>
                                &nbsp;
                                <span class="blink" *ngIf="item.is_exclu">Non garanti</span>
                                <span class="blink" *ngIf="item.is_entente_prealable && !item.is_traite">En attente préalable</span>
                                <span class="blink" *ngIf="item.is_entente_prealable && item.is_traite">
                                    Réjété ({{item.commentaire_validateur}})
                                </span>
                                <button class="btn-chat ms-1" (click)="openChatDialog(item)" title="Discuter">
                                    <i class="fa fa-comments"></i>
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="!itemsPrescription || !itemsPrescription.length" style="text-align: center;">
                            <td colspan="4">Aucune donnée disponible</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br><hr><br>
            <span class="mb-1 text-danger" style="font-size: 12px;">Acte à exécuter</span>

            <div [class.section-disabled]="!itemBeneficiare?.id">
                <div class="table-responsive">
                    <table class="table-bordered">
                        <thead>
                            <tr>
                                <th style="width: 2%;">#</th>
                                <th style="width: 25%;">Acte</th>
                                <th style="width: 25%;">Quantité</th>
                                <th style="width: 12%;">Montant</th>
                                <th style="width: 12%;">Dépassement</th>
                                <th style="width: 10%;">Part patient</th>
                                <th style="width: 10%;">Part assurance</th>
                                <th style="width: 10%;">Option</th>
                            </tr>
                        </thead>
                        <tbody style="font-weight: 500;">
                            <tr *ngFor="let item of itemsPrescriptionAservir;let indice=index">
                                <td>{{ indice+1 }}</td>
                                <td>{{ item.acte_libelle }}</td>
                                <td>{{ item.quantite }}</td>
                                <td style="text-align: right;">{{ item.montant | IntegerFormatPipe }}</td>
                                <td style="text-align: right;">
                                    <a *ngIf="item.depassement" (click)="showMessageDepassement(item)"
                                        style="text-decoration: underline;color: blue;cursor: pointer;">{{
                                        item.depassement | IntegerFormatPipe }}</a>
                                    <a *ngIf="!item.depassement">{{ item.depassement | IntegerFormatPipe }}</a>
                                </td>
                                <td style="text-align: right;">
                                    <a *ngIf="item.message_explicatif" (click)="showMessageExplicatif(item)"
                                        style="color: blue;text-decoration: underline;cursor: pointer;">{{
                                        (item.part_patient ||0) | IntegerFormatPipe}}</a>
                                    <a *ngIf="!item.message_explicatif">{{ (item.part_patient ||0) | IntegerFormatPipe}}</a>
                                </td>
                                <td style="text-align: right;">{{ (item.part_assurance ||0) | IntegerFormatPipe}}</td>
                                <td>
                                    <button (click)="removeMedicamentFromList(item)" class="btn btn-danger btn-sm"
                                        style="background-color: red;color: white;">Retirer</button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <td style="text-align: right;">{{getTotal() | IntegerFormatPipe}}</td>
                                <td style="text-align: right;">{{getTotalDepassement() | IntegerFormatPipe}}</td>
                                <td style="text-align: right;">{{getTotalPartPatient() | IntegerFormatPipe}}</td>
                                <td style="text-align: right;">{{getTotalPartAssurance() | IntegerFormatPipe}}</td>
                            </tr>
                            <tr *ngIf="!itemsPrescriptionAservir || !itemsPrescriptionAservir.length"
                                style="text-align: center;">
                                <td colspan="12">Aucune donnée disponible</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-2">
                    <div class="col-md-12"
                        *ngIf="itemToSave.montant_depassement && itemToSave.montant_depassement>0">
                        <div class="alert alert-danger text-center font-weight-bold shadow-lg p-4 rounded"
                            style="font-size: 1.2rem; border: 2px solid #dc3545;">
                            ⚠️ {{itemToSave.message_depassement}}
                            <hr class="my-3" style="border-color: #fff;">
                            <div class="text-left" style="font-size: 1rem;">
                                <p><strong>Nouveaux montants :</strong></p>
                                <p>💰 Part patient : <span class="text-danger"
                                        style="font-weight: 700;">{{itemToSave.part_patient | IntegerFormatPipe}} FCFA</span></p>
                                <p>🏥 Part assurance : <span class="text-success"
                                        style="font-weight: 700;">{{itemToSave.part_assurance | IntegerFormatPipe}} FCFA</span></p>
                            </div>
                            <div class="mt-3">
                                <button (click)="confirmSaveItem(itemToSave)"
                                    class="btn btn-outline-light btn-lg shadow-sm"
                                    style="font-weight:bold; background:gray">
                                    Souhaitez-vous continuer ?
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <button (click)="onActeDeepSeek()" [disabled]="!itemsPrescriptionAservir.length"
                            class="btn btn-primary btn-sm w-100">
                            Soumettre
                        </button>
                    </div>
                </div>
            </div><!-- /section-disabled -->

        </div>
    </div>

</div>

<!-- ── Modal nouvelle prescription ── -->
<div class="my-modal-overlay" *ngIf="showPresModal" (click)="showPresModal = false">
    <div class="my-modal" (click)="$event.stopPropagation()">
        <div class="my-modal-header d-flex justify-content-between align-items-center">
            <strong>Nouvelle prescription — Kiné</strong>
            <button class="my-close-btn" (click)="showPresModal = false">&times;</button>
        </div>
        <div class="my-modal-body">
            <app-form-pres-kine
                [matricule]="itemBeneficiare?.matricule"
                (onPrescriptionSaved)="onPrescriptionSaved()">
            </app-form-pres-kine>
        </div>
    </div>
</div>
